import React from 'react';
import { Chip } from "@mui/material";
import { PhoneOutlined } from "@mui/icons-material";
export const ReviewTypeChip = (props) => {
    const { didTalk, confirmAnalysis, timeSpent } = props;
    let labelText = '';
    if (confirmAnalysis) {
        if (timeSpent) {
            const flooredTime = Math.floor(parseFloat(timeSpent));
            labelText = 'Data Analysis: ' + flooredTime.toString();
        }
        else {
            labelText = 'Data Analysis';
        }
    }
    else {
        if (timeSpent) {
            const flooredTime = Math.floor(parseFloat(timeSpent));
            labelText = 'Other: ' + flooredTime.toString();
        }
        else {
            labelText = 'Other';
        }
    }
    if (didTalk) {
        return (React.createElement(Chip, { style: { background: '#00000014', color: '#2E7D32', cursor: 'default' }, label: labelText, size: 'small', onDelete: () => console.log('delete pressed'), deleteIcon: React.createElement(PhoneOutlined, null), sx: {
                '& .MuiChip-deleteIcon': {
                    '&:hover': {
                        color: '#00000042', // Prevent hover color change
                    },
                    cursor: 'default',
                    color: '#00000042'
                },
            } }));
    }
    else {
        return (React.createElement(Chip, { style: { background: '#00000014', color: '#2E7D32' }, label: labelText, size: 'small' }));
    }
};
